<template>
  <div class="claim-record">
    <!-- 搜索 -->
    <div class="search">
      <el-form
        :model="exportForm"
        ref="exportForm"
        class="demo-ruleForm"
      >
        <div class="form-row">
          <el-form-item prop="warehouseId" label="仓库名称：">
            <el-select
              v-model="exportForm.warehouseId"
              placeholder="请选择"
              @change="changeWarehouse"
            >
              <el-option
                v-for="item in warehouseList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
            <el-form-item prop="projectName" label="项目名称：">
              <el-select
                v-model="exportForm.projectName"
                placeholder="请选择"
                @change="changeProject"
              >
                <el-option
                  v-for="item in projectList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="date" label="日期：">
              <el-date-picker
                v-model="exportForm.date"
                type="date"
                placeholder="请选择日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
        </div>
        <div class="form-row">
          <el-form-item label="快递公司：" prop="expressId">
            <el-select
              class="white"
              v-model="exportForm.expressId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in expressList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" class="btn-blue" @click="searchData">搜索</el-button>
            <el-button icon="el-icon-refresh" class="btn-gray" @click="reset">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <div class="title-container">
      <p class="table-title">待确认表单</p>
      <el-upload
        element-loading-text="文件导入中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        class="upload tbc-upload"
        ref="upload"
        action="#"
        :show-file-list="false"
        :auto-upload="true"
        :before-upload="uploadClaimRegisterExcel"
      >
      
        <div class="upload-btn">
          <span class="upload-btn-img"></span>
          <span>导入</span>
        </div>
      </el-upload>
    </div>

    <!-- 待确认表达列表 -->
    <div class="table">
      <el-table 
        :data="tableData" 
        style="width: 100%" 
        :row-class-name="tableRowClassName"
        :header-cell-class-name="headerCellClassName"
      >
        <el-table-column
          v-for="(item, index) in tableTitle"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          show-overflow-tooltip
          :class-name="item.alignment === 'right'?`cell-right-align-width`:''"
        >
        </el-table-column>
        <el-table-column
          label="照片"
          width="100"
        >
          <template slot-scope="scope">
            <div class="upload-img">
              <el-tooltip effect="dark" placement="top" content="查看照片">
                <img @click="lookImg(scope.row.images)" class="eye" src="~assets/images/eye.png">
              </el-tooltip>
              <el-tooltip effect="dark" placement="top" content="上传照片">
                <el-upload
                  element-loading-text="文件上传中"
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(0, 0, 0, 0.8)"
                  class="upload"
                  ref="upload"
                  action="#"
                  :show-file-list="false"
                  :auto-upload="true"
                  :class="uploadImages.length < 3 ?'':'none'"
                  :limit="3"
                  multiple
                  :on-exceed="handleLimit"
                  :before-upload="uploadClaimImg"
                >
                    <img class="backtop-grey" @click="upload(scope.row.id)" src="~assets/images/backtop-grey.png">
                </el-upload>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="100">
          <template slot-scope="scope">
            <el-button
              v-if="!scope.row.isCancel&&!scope.row.isConfirmed"
              class="btn-text"
              type="text"
              @click="openConfirm(scope.row)"
            >确认</el-button>
            <el-button
              v-if="!scope.row.isCancel"
              class="btn-red-text"
              type="text"
              @click="nullify(scope.row.id)"
            >作废</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <pagination-tpl
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @queryChange="queryChange"
        ></pagination-tpl>
      </div>
    </div>

    <!-- 查看图片 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="430px"
      class="look-img"
      title="查看图片"
      :destroy-on-close="true"
    >
      <el-carousel arrow="always" indicator-position="none" :autoplay="false" @change="changeCarousel">
        <el-carousel-item v-for="(item, index) in images" :key="index">
          <img v-if="!isNothingImg" class="img" :src="item">
          <div v-else class="nothing-container">
            <img class="nothimg-img" :src="item">
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="indicator">
        <span class="indicator-high">
          {{ imgSort }}
        </span>/
        <span>
          {{ images.length }}
        </span>
      </div>
    </el-dialog>

    <!-- 确认 -->
    <el-drawer
      title="确认"
      :visible.sync="drawer"
      :wrapperClosable="false"
      :before-close="handleCloseDrawer">
      <div class="el-drawer__body">
        <el-form ref="confirmForm" :model="confirmForm" :rules="rules">
          <el-form-item label="责任归属" prop="responsibleParty">
            <el-select
              class="white"
              v-model="confirmForm.responsibleParty"
              placeholder="请选择"
            >
              <el-option
                v-for="item in responsiblePartyList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="确认金额" prop="payableAmount">
            <el-input v-model="confirmForm.payableAmount" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="备注：" prop="approvalRemarks" class="remarks">
            <el-input type="textarea" v-model="confirmForm.approvalRemarks" resize="none" class="white" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseDrawer">取消</el-button>
        <el-button class="btn-blue" @click="saveConfirm('confirmForm')">确定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Claim from "models/claim";
import warehouseMixins from "@/common/mixins/warehouse.js"
import projectMixins from "@/common/mixins/project.js"
import expressMixins from "@/common/mixins/express.js"
import claimMixins from "@/common/mixins/claim.js"
import statusMixins from "@/common/mixins/status.js"
import PaginationTpl from "components/base/PaginationTpl";
import ImgUploader from "common/js/img-upload.js";
const imgUploader = new ImgUploader();
import { numsToRMBSymbolAndMillimeter } from "common/js/util";
export default {
  mixins: [warehouseMixins, projectMixins, expressMixins, statusMixins, claimMixins],
  components: {
    PaginationTpl,
  },

  data() {
    return {
      exportForm: {
        warehouseId: '',
        date: "",
        customerId: '',
        projectName: '',
        expressId: '',
      },
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitle: [
        {label: '仓库', prop: 'warehouseName', width: '', salignment:'left'},
        {label: '时间', prop: 'billDate', width: '120', alignment:'left'},
        {label: '快递公司', prop: 'expressName', width: '120', alignment:'left'},
        {label: '操作人', prop: 'operator', width: '120', alignment:'left'},
        {label: '责任归属', prop: 'responsiblePartyVal', width: '120', alignment:'left'},
        {label: '问题分类', prop: 'logisticsProblemsTypeVal', width: '180', alignment:'left'},
        {label: '处理方案', prop: 'dealMethodVal', width: '120', alignment:'left'},
        {label: '订单号', prop: 'orderCode', width: '220', alignment:'left'},
        {label: '快递单号', prop: 'expressCode', width: '220', alignment:'left'},
        {label: '产品名称', prop: 'productName', width: '140', alignment:'left'},
        {label: '数量', prop: 'quantity', width: '150', alignment:'right'},
        {label: '申请金额', prop: 'involvedAmount', width: '150', alignment:'right'},
        {label: '客户名称', prop: 'customerName', width: '120', alignment:'left'},
        {label: '项目名称', prop: 'projectName', width: '120', alignment:'left'},
      ],
      
      // 索赔id
      claimId: null,
      loading: false,
      loading2: false,
      // 是否展示查看图片
      dialogVisible: false,
      // 图片序号
      imgSort: 1,
      images: [],
      // 是否展示缺省图
      isNothingImg: false,
      fileList: [],
      // 上传图片集合
      uploadImages: [],
      
      drawer: false,
      confirmForm: {
        responsibleParty: '',
        payableAmount: '',
        approvalRemarks: '',
        claimId: ''
      },
      rules: {
        responsibleParty: [
          { required: true, message: '请选择责任归属', trigger: 'change' }
        ],
        payableAmount: [
          { required: true, message: '请输入确认金额', trigger: 'blur' }
        ]
      },
    }
  },

  async created() {
    this.initWarehouse()
    this.initExpressList()
    await this.asyncInitProblemTypeList(1, true)
    this.initTBCRecord()
  },

  methods: {
    /** 
     * @desc 待确认表单
    */
    initTBCRecord() {
      let data = {
        warehouseId: this.exportForm.warehouseId,
        billDate: this.exportForm.date,
        expressId: this.exportForm.expressId,
        customerId: this.exportForm.customerId,
        projectId: this.exportForm.projectName,
        currentPage: this.currentPage
      }
      Claim.getTBCRecordList(data).then(res => {
        if (res.success) {
          this.total = res.result.totalNum
          this.pageSize = res.result.pageSize
          let arr = []
          res.result.items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.warehouseId = i.warehouseId
            obj.warehouseName = i.warehouseName
            obj.billDate = i.billDate
            obj.expressId = i.expressId
            obj.expressName = i.expressName
            obj.operator = i.operator
            obj.logisticsProblemsType = i.logisticsProblemsType
            this.logisticsProblemTypeList.map(v => {
              if (i.logisticsProblemsType == v.id) {
                obj.logisticsProblemsTypeVal = v.name
              }
            })
            obj.responsibleParty = i.responsibleParty
            obj.responsiblePartyVal = this.RESPONSIBLE_PARTY[i.responsibleParty]
            obj.dealMethod = i.dealMethod
            obj.dealMethodVal = this.DEAL_METHOD[i.dealMethod]
            obj.orderCode = i.orderCode
            obj.expressCode = i.expressCode
            obj.productName = i.productName
            obj.quantity = i.quantity
            obj.involvedAmount = numsToRMBSymbolAndMillimeter(i.involvedAmount)
            obj.customerName = i.customerName
            obj.projectName = i.projectName
            obj.images = i.imageList
            obj.isCancel = i.isCancel
            obj.isConfirmed = i.isConfirmed
            obj.isResponsible = i.isResponsible
            obj.responsibleParty = i.responsibleParty
            obj.payableAmount = i.payableAmount
            obj.carrierBearAmount = i.carrierBearAmount
            obj.approvalRemarks = i.approvalRemarks
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },
    
    /* 
      获取问题分类 
      type: true获取所有问题分类数据 false获取当前认责方的问题分类数据
    */
    async asyncInitProblemTypeList(responsibleType, type) {
      let res = await Claim.postProblemTypeList(responsibleType)
      if (res.success) {
        let arr = []
        res.result.map(i => {
          let obj = {}
          obj.id = i.id
          obj.name = i.text
          arr.push(obj)
        })
        if (type) {
          if (responsibleType == 1) {
            await this.asyncInitProblemTypeList(2, true)
          }
          this.logisticsProblemTypeList = this.logisticsProblemTypeList.concat(arr);
        }
      } else {
        this.$message.error(res.message)
      }
    },
    
    searchData() {
      this.currentPage = 1;
      this.initTBCRecord();
    },
    
    reset() {
      this.exportForm.date = ""
      this.exportForm.expressId = ""
      this.exportForm.warehouseId = ""
      this.exportForm.customerId = ""
      this.exportForm.projectName = ""
    },
    
    /** 
     * @desc 导入
    */
    uploadClaimRegisterExcel(file) {
      var formData = new FormData();
      formData.append("file", file);
      this.loading2 = true;
      Claim
        .postUploadClaimRegisterExcel(formData)
        .then(res => {
          if (res.success) {
            this.$message.success("导入成功");
            this.loading2 = false;
            this.initTBCRecord()
          } else {
            this.loading2 = false;
            this.$confirm(res.message, "提示", {
              showCancelButton: false,
              confirmButtonText: "确定",
              type: "warning"
            }).then(() => {});
          }
        })
        .catch(() => {
          this.$message.error("导入失败");
          this.loading2 = false;
        });
      return false;
    },

    /** 
     * @desc 作废
    */
    nullify(id) {
      this.$confirm("作废后，该确认索赔单将不可再次操作，请确认", "作废", {
        confirmButtonText: "作废",
        cancelButtonText: "取消",
        confirmButtonClass: "btn-red",
        cancelButtonClass: "btn-gray",
      }).then(() => {
        let data = {
          claimId: id
        }
        Claim.postNullifyClaimList(data).then(res => {
          if (res.success) {
            this.$message.success('作废成功')
            this.initTBCRecord()
          } else {
            this.$message.error(res.message)
          }
        })
      });
    },

    /** 
     * @desc 开启确认
    */
    openConfirm(row) {
      let responsibleType = 0
      if (row.responsibleParty != 3) {
        responsibleType = row.responsibleParty
      }
      this.asyncInitProblemTypeList(responsibleType, false)
      this.confirmForm.claimId = row.id
      this.confirmForm.responsibleParty = row.responsibleParty
      this.confirmForm.payableAmount = row.payableAmount
      this.confirmForm.approvalRemarks = row.approvalRemarks
      this.drawer = true
    },
    
    handleCloseDrawer() {
      this.$refs['confirmForm'].resetFields();
      this.drawer = false
    },
    
    /** 
     * @desc 确认
    */
    saveConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            claimId: this.confirmForm.claimId,
            responsibleParty: this.confirmForm.responsibleParty,
            payableAmount: Number(this.confirmForm.payableAmount),
            approvalRemarks: this.confirmForm.approvalRemarks,
          }
          Claim.postConfirmTBCRecord(data).then(res => {
            if (res.success) {
              this.handleCloseDrawer()
              this.initTBCRecord()
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    changeWarehouse() {
      let warehouseId = this.exportForm.warehouseId;
      this.initProjectListByWarehouse(warehouseId);
    },

    changeProject() {
      let obj = this.projectList.find(item => { return item.id == this.exportForm.projectName })
      this.exportForm.customerId = obj.customerId
    },

    /** 
     * @desc 为 Table 中的某一行添加 class
    */
    tableRowClassName({row}) {
      if (row.status !== 1) {
        return '';
      }
      return 'active';
    },

    /**
     * @desc 表头添加类名处理数字右对齐
     */
    headerCellClassName({ columnIndex }) {
      if (columnIndex > 9 && columnIndex < 12) {
        return 'right-align'
      }
    },

    /** 
     * @desc 翻页
    */
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initTBCRecord();
    },

    /** 
     * @desc 查看图片
    */
    lookImg(v) {
      this.imgSort = 1
      this.dialogVisible = true
      if (v.length > 0) {
        this.images = v
        this.isNothingImg = false
      } else {
        let img = require('../../../../assets/images/nothing/nothing.png')
        this.images = [img]
        this.isNothingImg = true
      }
    },

    /** 
     * @desc 获取轮播图序号
    */
    changeCarousel(v) {
      this.imgSort = v+1
    },
    
    /** 
     * @desc 图片数量大于3
    */
    handleLimit() {
      this.$message({
        message: "图片数量最多3张",
        type: "warning",
      });
    },

    /** 
     * @desc 上传
    */
    uploadClaimImg(file) {
      this.fileList = []
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/bmp" ||
        file.type === "image/jpg";
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isJPG) {
        this.$message.error("上传图片格式错误!");
        return false;
      } else if (!isLt1M) {
        this.$message.error("上传头像图片大小不能超过 1MB!");
        return false;
      } else {
        this.loading = true;
        this.file = file;
        imgUploader
          .postImgUpload(this.file)
          .then((res) => {
            if (res.errorCode === 0) {
              let obj = {};
              obj.url = res.imgUrl;
              this.fileList.push(obj);
              this.loading = false;
              this.uploadImages = [];
              this.fileList.map(value => {
                this.uploadImages.push(value.url);
              });
              this.uploadSuccess()
            } else {
              this.loading = false;
              this.$message.error("图片上传超时，请重新上传");
            }
          })
          .catch(() => {
            this.loading = false;
            this.$message.error("图片上传超时，请重新上传");
          });
        return false;
      }
    },

    uploadSuccess() {
      let data = {
        images: this.uploadImages,
        claimId: this.claimId
      }
      Claim.postUploadClaimImg(data).then(res => {
        if (res.success) {
          this.initTBCRecord()
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    
    upload(id) {
      this.claimId = id
    }
  }
}
</script>

<style lang='scss'>
@import "@/assets/style/layout/production/claim-record.scss";
</style>